import Flex from '@Components/Bases/Flex';
import FormRadio from '@Components/Form/FormRadio';
import { InputLabel, Typography } from '@mui/material';
import { StakeholderType } from '../../ImpactsOnStakeholdersFormProvider/types';

const StakeholderOptions = [
  { value: StakeholderType.INTERNAL, label: 'ผู้มีส่วนได้เสียภายในองค์กร' },
  { value: StakeholderType.EXTERNAL, label: 'ผู้มีส่วนได้เสียภายนอกองค์กร' },
];
const StakeholderRadio = () => {
  return (
    <Flex flexDirection="column">
      <Typography fontWeight={'bold'} mb={2}>
        ประเภทของกลุ่มผู้มีส่วนได้เสีย
      </Typography>
      <Flex sx={{ maxWidth: 510 }}>
        <InputLabel
          sx={{
            textAlign: 'right',
            marginRight: 1,
            width: '100%',
          }}
          required
        >
          ประเภทของผู้มีส่วนได้เสียที่เลือก
        </InputLabel>
        <FormRadio name="stakeholderType" options={StakeholderOptions} />
      </Flex>
    </Flex>
  );
};

export default StakeholderRadio;
